import * as service from './service'
import { HTTP_CODE } from '@/utils/request'
export default {
  namespace: 'siteSelection',
  state: {
    trainId: {}
  },
  effects: {
    * getMainData ({ payload }, { call, put }) {
      const res = yield call(service.getMainData, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    },
    * AgainTrain ({ payload }, { call, put }) {
      const res = yield call(service.AgainTrain, payload)
      yield put({
        type: 'save',
        payload: {
          trainId: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
